<template>
  <div v-loading="isLoading" class="container flex flex-col h-full p-4">
    <div class="w-full mt-6">
      <div class="relative flex items-center justify-center">
        <div class="flex items-center justify-center">
          <span
            class="txt-grey-900 text-3xl font-bold mt-1 leading-none text-pris uppercase"
            style="color: #20409b"
            >{{ $t("Tiếp Đón Bệnh Nhân") }}</span
          >
        </div>
      </div>

      <div>
        <search-appointment-data
          @addNewPatient="handleAddNewPatient"
          @setSearchInput="setSearchInput"
          @setIsLoading="setIsLoading"
        />

        <div
          class="flex justify-center text-blue-700 text-lg underline -mx-4 mb-4"
        >
          <div
            @click="onShowAppointmentModal()"
            class="px-4 cursor-pointer hover:text-blue-500 transition-colors duration-200"
          >
            <span class="mr-1">{{ $t("Lịch hẹn đã được đặt trước") }}</span>
            <span v-if="appointmentMetaData"
              >({{ appointmentMetaData && appointmentMetaData.total }})</span
            >
          </div>
          <div
            @click="onShowWaitingExaminationModal()"
            class="px-4 cursor-pointer hover:text-blue-500 transition-colors duration-200"
          >
            <span class="mr-1">{{ $t("Danh sách chờ khám") }}</span>
            <span v-if="waitingExaminationMetaData">
              ({{
                waitingExaminationMetaData && waitingExaminationMetaData.total
              }})
            </span>
          </div>
        </div>

        <div v-if="searchInput.length" class="relative">
          <div class="mb-2 font-bold">
            <span>{{
              $t(
                `Đã tìm thấy ${
                  (searchMetaResult && searchMetaResult.total) || 0
                } kết quả`
              )
            }}</span>
          </div>
          <div
            v-if="isLoading"
            class="absolute inset-0 rounded-md"
            v-loading="isLoading"
          ></div>
          <div
            class="overflow-x-hidden overflow-y-auto max-h-560"
            v-infinite-scroll="nextSearchPage"
            infinite-scroll-disabled="disabled"
          >
            <template v-if="searchInput.length && searchResult.length">
              <div
                v-for="result in searchResult"
                :key="result.id"
                class="flex flex-col bg-white border border-solid border-gray-200 rounded-md py-3 px-3 mb-2"
              >
                <div class="flex flex-wrap items-center">
                  <div class="mr-2">
                    <span class="text-base uppercase font-bold mr-4">{{
                      result.name
                    }}</span>
                    <span class="mr-4">
                      <span class="mr-1"
                        >{{ appUtils.getGender(result.gender) }},</span
                      >
                      <span class="mr-1">{{
                        appUtils.formatDate(result.birthday)
                      }}</span>
                      <span class="capitalize"
                        >({{
                          mdtUtils.getAges(new Date(result.birthday))
                        }})</span
                      >
                    </span>
                    <span>{{ result.address }}</span>
                  </div>
                  <!-- <pre>{{ result }}</pre> -->
                  <div class="ml-auto px-2">
                    <!-- <button
                      :disabled="isLoading"
                      @click="handleTriggerExamination(result)"
                      type="button"
                      class="flex items-center px-2 py-1 font-medium text-xs text-blue-800 whitespace-nowrap rounded-md border border-solid border-blue-800 bg-blue-50 hover:bg-blue-800 hover:text-white transition-all duration-200 mb-2"
                    >
                      <span class="inline-block w-3 h-3 mr-1">
                        <i class="el-icon-date" />
                      </span>
                      <span>{{ $t('Vào khám ngay') }}</span>
                    </button> -->
                    <button
                      :disabled="isLoading"
                      @click="onShowRegisterAppointment({ item: result })"
                      type="button"
                      class="flex items-center px-2 py-1 font-medium text-xs text-blue-800 whitespace-nowrap rounded-md border border-solid border-blue-800 bg-blue-50 hover:bg-blue-800 hover:text-white transition-all duration-200"
                    >
                      <span class="inline-block w-3 h-3 mr-1">
                        <i class="el-icon-date" />
                      </span>
                      <span>{{ $t("Đặt khám ngay") }}</span>
                    </button>
                  </div>
                </div>
                <div
                  v-for="(appt, index) in result.appts"
                  :key="index"
                  @click="rowClickHandler(appt)"
                  class="flex justify-between items-center cursor-pointer border-b border-t-0 border-l-0 border-r-0 border- border-solid border-gray-200 hover:bg-gray-200 transition-all duration-200 rounded-md p-2 my-2"
                >
                  <div class>
                    <div class="relative flex flex-wrap pl-3">
                      <i
                        class="absolute top-1/2 left-0 transform -translate-y-1/2 el-icon-date font-bold"
                      />
                      <div class="font-bold mr-4 pl-1">
                        <span>{{ appUtils.formatTime(appt.start_time) }}</span>
                        <span>:</span>
                        <span>{{ appUtils.formatTime(appt.end_time) }}</span>
                        <span>-</span>
                        <span>{{ appUtils.formatDate(appt.start_time) }}</span>
                      </div>
                      <div
                        class="mr-4"
                        v-if="appt.consulting_room && appt.consulting_room.name"
                      >
                        {{ appt.consulting_room.name }}
                      </div>
                      <div>{{ appt.doctor_name }}</div>
                    </div>
                    <div
                      v-if="appt.invoice"
                      class="relative flex items-center flex-wrap pl-3 mt-2"
                    >
                      <i
                        v-if="Number(appt.invoice.price)"
                        class="absolute top-1/2 left-0 transform -translate-y-1/2 el-icon-money font-bold"
                      />
                      <div class="mr-4 pl-1" v-if="Number(appt.invoice.price)">
                        {{
                          appUtils.formatToCurrency({
                            amount: Number(appt.invoice.price),
                          })
                        }}
                      </div>
                      <div
                        v-if="appt.invoice && Number(appt.invoice.status) > 0"
                        :set="[
                          (invoiceStatus = renderInvoiceStatus(
                            Number(appt.invoice.status)
                          )),
                        ]"
                      >
                        <span
                          :class="`px-2 py-1 text-xs rounded-full ${invoiceStatus.class}`"
                        >
                          {{ invoiceStatus.text }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div @click.stop class="flex items-center">
                    <button
                      v-if="
                        appt.invoice &&
                        (appt.invoice.status ===
                          INVOICE_STATUS.CODE.PATIENT_PENDING ||
                          appt.invoice.status ===
                            INVOICE_STATUS.CODE.PATIENT_PAID)
                      "
                      @click="onShowInvoiceModal({ item: appt })"
                      type="button"
                      class="flex items-center px-2 py-1 font-medium text-xs text-blue-800 whitespace-nowrap rounded-md border border-solid border-blue-800 bg-blue-50 hover:bg-blue-800 hover:text-white transition-all duration-200"
                    >
                      <span class="inline-block w-3 h-3 mr-1 -mt-0.5">
                        <svg
                          viewBox="0 0 32 32"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M14.667 20.0013V17.3346C13.6061 17.3346 12.5887 16.9132 11.8386 16.1631C11.0884 15.4129 10.667 14.3955 10.667 13.3346C10.667 12.2738 11.0884 11.2564 11.8386 10.5062C12.5887 9.75606 13.6061 9.33464 14.667 9.33464V8.0013C14.667 7.64768 14.8075 7.30854 15.0575 7.05849C15.3076 6.80844 15.6467 6.66797 16.0003 6.66797C16.3539 6.66797 16.6931 6.80844 16.9431 7.05849C17.1932 7.30854 17.3337 7.64768 17.3337 8.0013V9.33464H17.363C18.4161 9.33464 19.426 9.75297 20.1707 10.4976C20.9153 11.2423 21.3337 12.2522 21.3337 13.3053C21.3337 13.6589 21.1932 13.9981 20.9431 14.2481C20.6931 14.4982 20.3539 14.6386 20.0003 14.6386C19.6467 14.6386 19.3076 14.4982 19.0575 14.2481C18.8075 13.9981 18.667 13.6589 18.667 13.3053C18.667 12.9595 18.5296 12.6278 18.2851 12.3832C18.0405 12.1387 17.7088 12.0013 17.363 12.0013H17.3337V14.668C18.3945 14.668 19.4119 15.0894 20.1621 15.8395C20.9122 16.5897 21.3337 17.6071 21.3337 18.668C21.3337 19.7288 20.9122 20.7462 20.1621 21.4964C19.4119 22.2465 18.3945 22.668 17.3337 22.668V24.0013C17.3337 24.3549 17.1932 24.6941 16.9431 24.9441C16.6931 25.1942 16.3539 25.3346 16.0003 25.3346C15.6467 25.3346 15.3076 25.1942 15.0575 24.9441C14.8075 24.6941 14.667 24.3549 14.667 24.0013V22.668H14.599C13.5562 22.668 12.556 22.2537 11.8186 21.5163C11.0813 20.7789 10.667 19.7788 10.667 18.736C10.667 18.3823 10.8075 18.0432 11.0575 17.7932C11.3076 17.5431 11.6467 17.4026 12.0003 17.4026C12.3539 17.4026 12.6931 17.5431 12.9431 17.7932C13.1932 18.0432 13.3337 18.3823 13.3337 18.736C13.334 19.0714 13.4674 19.3931 13.7047 19.6303C13.9419 19.8675 14.2635 20.0009 14.599 20.0013H14.667ZM17.3337 20.0013C17.6873 20.0013 18.0264 19.8608 18.2765 19.6108C18.5265 19.3607 18.667 19.0216 18.667 18.668C18.667 18.3143 18.5265 17.9752 18.2765 17.7252C18.0264 17.4751 17.6873 17.3346 17.3337 17.3346V20.0013ZM14.667 12.0013C14.3134 12.0013 13.9742 12.1418 13.7242 12.3918C13.4741 12.6419 13.3337 12.981 13.3337 13.3346C13.3337 13.6883 13.4741 14.0274 13.7242 14.2774C13.9742 14.5275 14.3134 14.668 14.667 14.668V12.0013ZM16.0003 29.3346C8.63633 29.3346 2.66699 23.3653 2.66699 16.0013C2.66699 8.6373 8.63633 2.66797 16.0003 2.66797C23.3643 2.66797 29.3337 8.6373 29.3337 16.0013C29.3337 23.3653 23.3643 29.3346 16.0003 29.3346ZM16.0003 26.668C18.8293 26.668 21.5424 25.5442 23.5428 23.5438C25.5432 21.5434 26.667 18.8303 26.667 16.0013C26.667 13.1723 25.5432 10.4592 23.5428 8.45883C21.5424 6.45844 18.8293 5.33464 16.0003 5.33464C13.1713 5.33464 10.4582 6.45844 8.45785 8.45883C6.45747 10.4592 5.33366 13.1723 5.33366 16.0013C5.33366 18.8303 6.45747 21.5434 8.45785 23.5438C10.4582 25.5442 13.1713 26.668 16.0003 26.668V26.668Z"
                            fill="currentColor"
                          />
                        </svg>
                      </span>
                      <span>{{ $t("Thanh toán") }}</span>
                    </button>
                    <button
                      v-if="Number(appt.examination_status) === 0"
                      @click="onHandleCheckInUser({ item: appt })"
                      type="button"
                      class="flex items-center px-2 py-1 ml-2 font-medium text-xs text-blue-800 whitespace-nowrap rounded-md border border-solid border-blue-800 bg-blue-50 hover:bg-blue-800 hover:text-white transition-all duration-200"
                    >
                      <span class="inline-block w-3 h-3 mr-1 -mt-0.5">
                        <svg
                          viewBox="0 0 32 32"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12.4495 20.438V21.225C12.4495 22.8362 13.0895 24.3814 14.2288 25.5207C15.368 26.66 16.9131 27.3 18.5242 27.3C20.1353 27.3 21.6804 26.66 22.8197 25.5207C23.9589 24.3814 24.5989 22.8362 24.5989 21.225V18.9705C23.6978 18.652 22.9384 18.0252 22.4547 17.2009C21.9711 16.3766 21.7944 15.4078 21.956 14.4658C22.1176 13.5239 22.6069 12.6693 23.3376 12.0533C24.0682 11.4372 24.9932 11.0993 25.9488 11.0993C26.9045 11.0993 27.8295 11.4372 28.5601 12.0533C29.2908 12.6693 29.7801 13.5239 29.9417 14.4658C30.1032 15.4078 29.9266 16.3766 29.443 17.2009C28.9593 18.0252 28.1998 18.652 27.2988 18.9705V21.225C27.2988 23.5523 26.3743 25.7842 24.7288 27.4299C23.0832 29.0755 20.8514 30 18.5242 30C16.1971 30 13.9652 29.0755 12.3197 27.4299C10.6741 25.7842 9.74966 23.5523 9.74966 21.225V20.438C7.86236 20.1184 6.14914 19.1409 4.91366 17.6788C3.67819 16.2166 3.00025 14.3643 3 12.45L3 5.7C3 4.98392 3.28445 4.29716 3.79077 3.79081C4.29709 3.28446 4.98382 3 5.69986 3H7.0498C7.40782 3 7.75118 3.14223 8.00434 3.39541C8.2575 3.64858 8.39973 3.99196 8.39973 4.35C8.39973 4.70804 8.2575 5.05142 8.00434 5.30459C7.75118 5.55777 7.40782 5.7 7.0498 5.7H5.69986V12.45C5.69986 13.8822 6.26876 15.2557 7.28141 16.2684C8.29405 17.2811 9.6675 17.85 11.0996 17.85C12.5317 17.85 13.9051 17.2811 14.9178 16.2684C15.9304 15.2557 16.4993 13.8822 16.4993 12.45V5.7H15.1494C14.7914 5.7 14.448 5.55777 14.1948 5.30459C13.9417 5.05142 13.7995 4.70804 13.7995 4.35C13.7995 3.99196 13.9417 3.64858 14.1948 3.39541C14.448 3.14223 14.7914 3 15.1494 3H16.4993C17.2154 3 17.9021 3.28446 18.4084 3.79081C18.9147 4.29716 19.1992 4.98392 19.1992 5.7V12.45C19.1989 14.3643 18.521 16.2166 17.2855 17.6788C16.05 19.1409 14.3368 20.1184 12.4495 20.438ZM25.9488 16.5C26.3069 16.5 26.6502 16.3578 26.9034 16.1046C27.1566 15.8514 27.2988 15.508 27.2988 15.15C27.2988 14.792 27.1566 14.4486 26.9034 14.1954C26.6502 13.9422 26.3069 13.8 25.9488 13.8C25.5908 13.8 25.2475 13.9422 24.9943 14.1954C24.7411 14.4486 24.5989 14.792 24.5989 15.15C24.5989 15.508 24.7411 15.8514 24.9943 16.1046C25.2475 16.3578 25.5908 16.5 25.9488 16.5Z"
                            fill="currentColor"
                          />
                        </svg>
                      </span>
                      <span>{{ $t("Xác nhận có mặt") }}</span>
                    </button>
                    <button
                      v-if="Number(appt.examination_status) === 1"
                      :disabled="true"
                      type="button"
                      class="flex items-center px-2 py-1 ml-2 font-medium text-xs text-blue-800 whitespace-nowrap rounded-md border border-solid border-blue-800 bg-blue-50 hover:text-white transition-all duration-200 cursor-not-allowed"
                    >
                      <span class="inline-block w-3 h-3 mr-1 -mt-0.5">
                        <svg
                          viewBox="0 0 32 32"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12.4495 20.438V21.225C12.4495 22.8362 13.0895 24.3814 14.2288 25.5207C15.368 26.66 16.9131 27.3 18.5242 27.3C20.1353 27.3 21.6804 26.66 22.8197 25.5207C23.9589 24.3814 24.5989 22.8362 24.5989 21.225V18.9705C23.6978 18.652 22.9384 18.0252 22.4547 17.2009C21.9711 16.3766 21.7944 15.4078 21.956 14.4658C22.1176 13.5239 22.6069 12.6693 23.3376 12.0533C24.0682 11.4372 24.9932 11.0993 25.9488 11.0993C26.9045 11.0993 27.8295 11.4372 28.5601 12.0533C29.2908 12.6693 29.7801 13.5239 29.9417 14.4658C30.1032 15.4078 29.9266 16.3766 29.443 17.2009C28.9593 18.0252 28.1998 18.652 27.2988 18.9705V21.225C27.2988 23.5523 26.3743 25.7842 24.7288 27.4299C23.0832 29.0755 20.8514 30 18.5242 30C16.1971 30 13.9652 29.0755 12.3197 27.4299C10.6741 25.7842 9.74966 23.5523 9.74966 21.225V20.438C7.86236 20.1184 6.14914 19.1409 4.91366 17.6788C3.67819 16.2166 3.00025 14.3643 3 12.45L3 5.7C3 4.98392 3.28445 4.29716 3.79077 3.79081C4.29709 3.28446 4.98382 3 5.69986 3H7.0498C7.40782 3 7.75118 3.14223 8.00434 3.39541C8.2575 3.64858 8.39973 3.99196 8.39973 4.35C8.39973 4.70804 8.2575 5.05142 8.00434 5.30459C7.75118 5.55777 7.40782 5.7 7.0498 5.7H5.69986V12.45C5.69986 13.8822 6.26876 15.2557 7.28141 16.2684C8.29405 17.2811 9.6675 17.85 11.0996 17.85C12.5317 17.85 13.9051 17.2811 14.9178 16.2684C15.9304 15.2557 16.4993 13.8822 16.4993 12.45V5.7H15.1494C14.7914 5.7 14.448 5.55777 14.1948 5.30459C13.9417 5.05142 13.7995 4.70804 13.7995 4.35C13.7995 3.99196 13.9417 3.64858 14.1948 3.39541C14.448 3.14223 14.7914 3 15.1494 3H16.4993C17.2154 3 17.9021 3.28446 18.4084 3.79081C18.9147 4.29716 19.1992 4.98392 19.1992 5.7V12.45C19.1989 14.3643 18.521 16.2166 17.2855 17.6788C16.05 19.1409 14.3368 20.1184 12.4495 20.438ZM25.9488 16.5C26.3069 16.5 26.6502 16.3578 26.9034 16.1046C27.1566 15.8514 27.2988 15.508 27.2988 15.15C27.2988 14.792 27.1566 14.4486 26.9034 14.1954C26.6502 13.9422 26.3069 13.8 25.9488 13.8C25.5908 13.8 25.2475 13.9422 24.9943 14.1954C24.7411 14.4486 24.5989 14.792 24.5989 15.15C24.5989 15.508 24.7411 15.8514 24.9943 16.1046C25.2475 16.3578 25.5908 16.5 25.9488 16.5Z"
                            fill="currentColor"
                          />
                        </svg>
                      </span>
                      <span>{{ $t("Đã có mặt") }}</span>
                    </button>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div
                class="flex flex-col items-center text-lg bg-white border border-solid border-gray-200 rounded-md py-3 px-3 mb-2"
              >
                <span>{{ $t("Không tìm thấy thông tin") }}</span>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>

    <custom-modal
      :showModal="showAppointmentModal"
      @hideModal="hideModal"
      :title="$t('Lịch hẹn đã được đặt trước')"
      :count="appointmentMetaData && appointmentMetaData.total"
    >
      <appointment-modal
        v-if="showAppointmentModal"
        :items="appointmentsData"
        :metaData="appointmentMetaData"
        @setFilters="setFiltersAppointment"
        :refreshFilters="refreshFilters"
        @refresh="onRefresh"
        @onChangePagination="handleChangeAppointmentPagination"
      />
    </custom-modal>

    <custom-modal
      :showModal="showWaitingExaminationModal"
      @hideModal="hideModal"
      :title="$t('Danh sách chờ khám')"
      :count="waitingExaminationMetaData && waitingExaminationMetaData.total"
    >
      <waiting-examination-modal
        @onChangePagination="handleChangeWaitingExamPagination"
        v-if="showWaitingExaminationModal"
        :items="waitingExaminationsData"
        :metaData="waitingExaminationMetaData"
        @setFilters="setFiltersWaitingExamination"
        :refreshFilters="refreshFilters"
        @refresh="onRefresh"
      />
    </custom-modal>

    <custom-modal
      :showModal="showInvoiceModal"
      @hideModal="hideModal"
      :title="$t('Xác nhận thanh toán lịch hẹn')"
      titleClass="uppercase text-3xl w-full text-center"
    >
      <template
        v-if="
          selectedAppt &&
          selectedAppt.invoice !== null &&
          selectedAppt.invoice.token
        "
      >
        <invoice-detail
          :invoiceId="selectedAppt.invoice.id"
          :token="selectedAppt.invoice.token"
          :breadcrumb="false"
          @onRefresh="onRefresh"
        />
      </template>
    </custom-modal>

    <custom-modal
      :showModal="showRegisterAppointment"
      @hideModal="hideModal"
      :title="$t('Đăng ký lịch hẹn')"
    >
      <template v-if="selectedPerson">
        <appointment-form
          :personData="selectedPerson"
          v-show="step === 'input'"
          @nextStep="nextStep"
        />
        <appointment-confirm
          v-if="step === 'confirm'"
          :data="apptDataRaw"
          @backStep="step = 'input'"
          :returnRoute="returnRoute"
        />
      </template>
    </custom-modal>

    <ModalPatientInfo ref="ModalPatientInfo" @refresh="onRefreshPerson" />
  </div>
</template>

<script>
// import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import { mapGetters, mapActions } from 'vuex'
import AppointmentModal from './AppointmentModal'
import WaitingExaminationModal from './WaitingExaminationModal'
import CustomModal from '../../../components/CustomModal'
import {
  APPOINTMENT_STATUS,
  EXAMINATION_STATUS,
  INVOICE_STATUS,
  PATIENT_RECEPTION_TYPE
} from '../../../utils/constants'
import SearchAppointmentData from './SearchAppointmentData'
import appUtils from '../../../utils/appUtils'
import mdtUtils from '../../../utils/mdtUtils'
import InvoiceDetail from '../../../components/InvoiceDetail'
import AppointmentForm from '../../../components/Appointment/v2/AppointmentForm'
import AppointmentConfirm from '../../../components/Appointment/v2/AppointmentConfirm'
import ModalPatientInfo from '../../../components/Patient/ModalPatientInfo.vue'

export default {
  name: 'AppointmentManagementV2',
  components: {
    SearchAppointmentData,
    AppointmentModal,
    WaitingExaminationModal,
    CustomModal,
    InvoiceDetail,
    AppointmentForm,
    AppointmentConfirm,
    ModalPatientInfo
  },
  data () {
    return {
      isLoading: false,
      today: window.moment(),
      startTodayUnix: window
        .moment(window.moment().startOf('day').toDate())
        .unix(),
      endTodayUnix: window.moment(window.moment().endOf('day').toDate()).unix(),
      showAppointmentModal: false,
      showWaitingExaminationModal: false,
      showInvoiceModal: false,
      showRegisterAppointment: false,
      limit: 20,
      defaultFilter: {
        fromDate: window.moment().format('YYYY-MM-DD'),
        toDate: window.moment().format('YYYY-MM-DD'),
        status: APPOINTMENT_STATUS.CODE.CLINIC_PENDING
      },
      searchInput: '',
      searchResult: [],
      searchMetaResult: null,
      appointmentsData: [],
      appointmentMetaData: null,
      appointmentFilterParams: null,
      waitingExaminationsData: [],
      waitingExaminationMetaData: null,
      waitingExaminationFilterParams: null,
      isRefreshFilter: false,
      timer: null,
      appUtils,
      mdtUtils,
      APPOINTMENT_STATUS,
      INVOICE_STATUS,
      selectedAppt: null,
      selectedPerson: null,
      step: 'input',
      apptDataRaw: null,
      returnRoute: {
        name: 'AppointmentDetailV2',
        query: {
          type: PATIENT_RECEPTION_TYPE.CODE.APPOINTMENT
        }
      },
      nextPage: 1,
      page: 1,
      currentDate: window.moment().format('YYYY-MM-DD'),
      consulting: []
    }
  },
  watch: {
    searchData (data) {
      if (data) {
        if (this.nextPage > 1) {
          this.searchResult = [...this.searchResult, ...data]
          return
        }

        this.searchResult = data
      }
    },
    searchAllMeta (data) {
      if (data) {
        this.searchMetaResult = data
      }
    },
    appointments (data) {
      if (data) {
        // const _tempAppointmentsData = data?.filter((d) => ((Number(d?.status) === APPOINTMENT_STATUS.CODE.CLINIC_PENDING) || (Number(d?.status) === APPOINTMENT_STATUS.CODE.PATIENT_ACCEPTED)) && (Number(d?.examination_status) === 0))
        this.appointmentsData = data
      }
    },
    appointmentMeta (data) {
      if (data) {
        // const _tempAppointmentMetaData = {
        //   ...data,
        //   count: this.appointmentsData?.length || 0,
        //   total: this.appointmentsData?.length || 0,
        //   last_page: !this.appointmentsData?.length
        //     ? 0
        //     : this.appointmentsData?.length > Number(data.per_page)
        //       ? Math.ceil(this.appointmentsData?.length / data.per_page)
        //       : 1
        // }

        this.appointmentMetaData = data
      }
    },
    waitingExaminations (data) {
      if (data) {
        // const _tempWaitingExaminationsData = data?.filter((d) => (Number(d?.examination_status) === WAITING_EXAMINATION_STATUS.CODE.WAITING))
        this.waitingExaminationsData = data
      }
    },
    waitingExaminationMeta (data) {
      if (data) {
        // const _tempWaitingExaminationMeta = {
        //   ...data,
        //   count: this.waitingExaminationsData?.length || 0,
        //   total: this.waitingExaminationsData?.length || 0,
        //   last_page: !this.waitingExaminationsData?.length
        //     ? 0
        //     : this.waitingExaminationsData?.length > Number(data.per_page)
        //       ? Math.ceil(this.waitingExaminationsData?.length / data.per_page)
        //       : 1
        // }

        this.waitingExaminationMetaData = data?.page
      }
    }
  },
  created () {
    const self = this
    self.appointmentFilterParams = self.waitingExaminationFilterParams =
      self.defaultFilter

    self.getAppointments({
      limit: 1000,
      page: self.page,
      params: self.appointmentFilterParams
    })
    self.getWaitingExaminations({
      limit: self.limit,
      page: self.page,
      params: self.waitingExaminationFilterParams
    })

    self.timer = setInterval(function () {
      self.getAppointments({
        limit: self.limit,
        page: self.page,
        params: self.showAppointmentModal
          ? self.appointmentFilterParams
          : self.defaultFilter
      })
      self.getWaitingExaminations({
        limit: self.limit,
        page: self.page,
        params: self.showWaitingExaminationModal
          ? self.waitingExaminationFilterParams
          : self.defaultFilter
      })
    }, 1000 * 30) // refetch 30s

    // window.addEventListener('keydown', (e) => {
    //   if (e.key === 'Escape') {
    //     self.hideModal()
    //   }
    // })
  },
  computed: {
    ...mapGetters({
      searchData: 'appointmentStore/searchAllData',
      searchAllMeta: 'appointmentStore/searchAllMeta',
      appointments: 'appointmentStore/allAppointments',
      appointmentMeta: 'appointmentStore/allAppointmentMeta',
      waitingExaminations: 'appointmentStore/allWaitingExaminations',
      waitingExaminationMeta: 'appointmentStore/allWaitingExaminationMeta'
    }),
    refreshFilters () {
      if (this.isRefreshFilter) {
        this.appointmentFilterParams = null
        this.waitingExaminationFilterParams = this.defaultFilter
      }

      return this.isRefreshFilter
    },
    noMore () {
      return this.nextPage >= (this.searchMetaResult?.last_page || 1)
    },
    disabled () {
      return this.isLoading || this.noMore
    }
  },
  mounted () {
    window.scroll(0, 0)
    this.getConsultingRooms()
  },
  methods: {
    ...mapActions('appointmentStore', [
      'getSearchAllRequest',
      'getAppointmentRequest',
      'getWaitingExaminationRequest',
      'checkInUser'
    ]),
    cancelAutoUpdate () {
      clearInterval(this.timer)
    },
    onShowAppointmentModal () {
      this.showAppointmentModal = true
      this.isRefreshFilter = false
      this.appointmentFilterParams = this.defaultFilter
      this.getAppointments({
        limit: 20,
        page: 1,
        params: this.appointmentFilterParams
      })
    },
    onShowWaitingExaminationModal () {
      this.showWaitingExaminationModal = true
      this.isRefreshFilter = false
      this.waitingExaminationFilterParams = this.defaultFilter
      this.getWaitingExaminations({
        limit: 20,
        page: 1,
        params: this.waitingExaminationFilterParams
      })
    },
    onShowInvoiceModal ({ item }) {
      this.selectedAppt = item
      this.showInvoiceModal = true
    },
    onShowRegisterAppointment ({ item }) {
      this.selectedPerson = item
      this.showRegisterAppointment = true
    },
    hideModal () {
      this.showAppointmentModal = false
      this.showWaitingExaminationModal = false

      this.showInvoiceModal = false
      this.selectedAppt = null

      this.isRefreshFilter = true

      this.showRegisterAppointment = false
      this.selectedPerson = null
      this.step = 'input'
      this.limit = 1000
      this.page = 1

      this.onRefresh()
    },
    setParamsData ({ limit = 10, page = 1, data }) {
      let params = {
        page_size: limit,
        sort_by: 'start_time',
        order: 'desc',
        page_num: page,
        clinic_id: this.$clinicId
      }

      if (data?.search?.length) {
        params.search = data.search
      }

      if (
        (data?.fromDate && !data?.toDate) ||
        (!data?.fromDate && data?.toDate)
      ) {
        return
      }

      if (data?.fromDate && data?.toDate) {
        params.start_time = this.moment(data?.fromDate).startOf('day').format('YYYY-MM-DD HH:mm:ss')
        params.end_time = this.moment(data?.toDate).endOf('day').format('YYYY-MM-DD HH:mm:ss')
      }
      // else {
      //   params.start_time = this.moment().startOf('day').toDate()
      //   params.end_time = this.moment(this.moment().add(6, 'months')).endOf('day').toDate()
      //   params.limit = 1000
      //   params.page = 1
      // }

      if (Number(data?.room)) {
        params.cr_id = Number(data.room)
      }

      if (Number(data?.payment) > 0) {
        params.invoice_status = Number(data.payment)
      }

      if (Number(data?.status) === APPOINTMENT_STATUS.CODE.PATIENT_CANCELLED) {
        params.multi_status = APPOINTMENT_STATUS.CODE.PATIENT_CANCELLED
        params.examination_statuses = '0'
      } else if (
        Number(data?.status) === APPOINTMENT_STATUS.CODE.CLINIC_CONFIRMED
      ) {
        params.multi_status = [
          APPOINTMENT_STATUS.CODE.CLINIC_PENDING,
          APPOINTMENT_STATUS.CODE.PATIENT_ACCEPTED
        ].join(',')
        params.examination_statuses = '1'
      } else if (
        Number(data?.status) === APPOINTMENT_STATUS.CODE.CLINIC_PENDING
      ) {
        params.multi_status = [
          APPOINTMENT_STATUS.CODE.CLINIC_PENDING,
          APPOINTMENT_STATUS.CODE.PATIENT_ACCEPTED
        ].join(',')
        params.examination_statuses = '0'
      } else {
        params.multi_status = [
          APPOINTMENT_STATUS.CODE.CLINIC_PENDING,
          // APPOINTMENT_STATUS.CODE.CLINIC_CONFIRMED,
          APPOINTMENT_STATUS.CODE.PATIENT_ACCEPTED,
          APPOINTMENT_STATUS.CODE.PATIENT_CANCELLED
        ].join(',')
        params.examination_statuses = '0,1'
      }

      if (Number(data?.doctor) > 0) {
        params.doctor_id = Number(data.doctor)
      }

      return params
    },
    getAppointments ({
      limit = this.limit || 10,
      page = 1,
      params = {},
      refetch = true
    }) {
      try {
        let paramsData = this.setParamsData({
          limit,
          page,
          data: params
        })
        this.limit = limit
        this.page = page

        this.getAppointmentRequest({ params: paramsData, refetch })
      } catch (error) {
        console.log(error)
      }
    },
    getWaitingExaminations ({
      limit = this.limit || 10,
      page = 1,
      params = {},
      refetch = true
    }) {
      try {
        let paramsData = this.setParamsData({
          limit,
          page,
          data: params
        })

        const { multi_status, ...newParamsData } = paramsData
        let newParams = null

        if (params.status === 'All') {
          newParams = {
            ...newParamsData,
            multi_status: [
              EXAMINATION_STATUS.CODE.WAITING,
              EXAMINATION_STATUS.CODE.CANCELED
            ].join(',')
          }
        } else {
          newParams = {
            ...newParamsData,
            status: params.status
          }
        }

        this.getWaitingExaminationRequest({ params: newParams, refetch })
      } catch (error) {
        console.log(error)
      }
    },
    setFiltersAppointment (params) {
      this.appointmentFilterParams = {
        ...this.appointmentFilterParams,
        ...params
      }
      this.getAppointments({ params: this.appointmentFilterParams })
    },
    setFiltersWaitingExamination (params) {
      this.waitingExaminationFilterParams = {
        ...this.waitingExaminationFilterParams,
        ...params
      }
      this.getWaitingExaminations({
        params: this.waitingExaminationFilterParams
      })
    },
    handleAddNewPatient () {
      this.$refs.ModalPatientInfo.openDialog()
    },
    onRefresh (params) {
      if (this.showAppointmentModal) {
        this.getAppointments({
          limit: this.limit,
          params: this.appointmentFilterParams
        })
      } else {
        this.getAppointments({ limit: this.limit, params: this.defaultFilter })
      }

      if (this.showWaitingExaminationModal) {
        this.getWaitingExaminations({
          limit: this.limit,
          params: this.waitingExaminationFilterParams
        })
      } else {
        this.waitingExaminationFilterParams = this.defaultFilter
        this.getWaitingExaminations({
          limit: this.limit,
          params: this.defaultFilter
        })
      }

      if (this.searchInput.length) {
        this.getSearchAppointments({ keyword: this.searchInput })
      }
    },
    onRefreshPerson (data) {
      this.getPersonDetail()
      this.onShowRegisterAppointment({ item: data })
    },
    async getPersonDetail () {
      const params = {
        clinic_id: this.$globalClinic?.id,
        page: 1,
        limit: 10,
        sort: 'created_at',
        sort_by: 'desc'
      }
      await this.$rf.getRequest('DoctorRequest').getPersonsV2(params)
    },
    async onHandleCheckInUser ({ item }) {
      const self = this

      if (
        this.moment(item?.start_time).startOf('day').toDate() -
          this.moment().startOf('day').toDate() !==
        0
      ) {
        self.$alert(
          self.$t('Lịch hẹn không phải ngày hôm nay'),
          self.$t('Bạn không thể xác nhận lịch hẹn này')
        )
        return
      }

      try {
        self
          .$confirm(self.$t('Bạn xác nhận bệnh nhân đã có mặt tại phòng khám?'))
          .then(async (_) => {
            try {
              self.isLoading = true

              const paramsData = {
                clinic_id: item.clinic_id,
                cr_id: item.cr_id,
                doctor_id: item.doctor_id,
                person_id: item.person_id,
                start_time: item.start_time,
                end_time: item.end_time
              }

              const results = await self.checkInUser({
                id: item.id,
                data: {
                  ...paramsData,
                  appt_id: item.id,
                  method:
                    item.method || PATIENT_RECEPTION_TYPE.CODE.APPOINTMENT,
                  visit_reason: item.appt_reason,
                  checkin_time: self.moment()
                },
                apptData: item
              })

              if (results?.patientVisit?.id) {
                self.$router.push({
                  name: 'AppointmentDetailV2',
                  params: {
                    id: results?.patientVisit?.id
                  },
                  query: {
                    type: PATIENT_RECEPTION_TYPE.CODE.WAITING_EXAMINATION
                  }
                })
              }
            } catch (error) {
              console.log(error)
              self.isLoading = false
            } finally {
              self.isLoading = false
              // self.$message({
              //   type: 'success',
              //   message: self.$t('Xác nhận thành công!')
              // })
            }
          })
          .catch((_) => {})
      } catch (error) {
        console.log(error)
      }
    },
    rowClickHandler (record, index) {
      if (record) {
        this.$router.push({
          name: 'AppointmentDetailV2',
          params: { id: record.id }
        })
      }
    },
    setSearchInput (value) {
      this.nextPage = 1
      this.searchResult = []
      this.searchMetaResult = null
      this.searchInput = value
    },
    setIsLoading (value) {
      this.isLoading = value
    },
    renderInvoiceStatus (stt) {
      const status = [
        {},
        {
          text: this.$t('Chưa thanh toán'),
          class: 'text-red-700 bg-red-50'
        },
        {
          text: this.$t('Chờ xác nhận'),
          class: 'text-yellow-900 bg-yellow-100'
        },
        {
          text: this.$t('Đã thanh toán'),
          class: 'text-green-700 bg-green-50'
        }
      ]
      return status[stt]
        ? status[stt]
        : status[INVOICE_STATUS.CODE.PATIENT_PENDING]
    },
    nextStep (data) {
      if (!data) return
      this.apptDataRaw = data
      this.step = 'confirm'
    },
    async getSearchAppointments ({ keyword, params }) {
      const self = this

      if (!keyword?.length) {
        return
      }

      self.isLoading = true

      let paramsData = {
        search: keyword,
        limit: 10,
        sort: 'start_time',
        sort_by: 'desc',
        page: 1,
        clinic_id: self.$clinicId
      }

      paramsData = {
        ...paramsData,
        ...params
      }

      try {
        await self.getSearchAllRequest({ params: paramsData })
      } catch (error) {
        console.log(error)
        self.isLoading = false
      } finally {
        self.isLoading = false
      }
    },
    async nextSearchPage () {
      if (!this.searchInput.length) return

      this.nextPage += 1
      await this.getSearchAppointments({
        keyword: this.searchInput,
        params: {
          page: this.nextPage
        }
      })
    },
    handleChangeAppointmentPagination (params) {
      this.limit = params.per_page || this.limit
      this.page = params.page || this.page

      this.getAppointments({
        page: params.page,
        limit: params.per_page,
        params: { ...this.appointmentFilterParams }
      })
    },
    handleChangeWaitingExamPagination (params) {
      this.limit = params.per_page || this.limit
      this.page = params.page || this.page

      this.getWaitingExaminations({
        page: params.page,
        limit: params.per_page,
        params: { ...this.waitingExaminationFilterParams }
      })
    },
    async handleTriggerExamination (item) {
      try {
        this.isLoading = true
        const responseCreateAppt = await this.handleCreateAppointment(item)
        if (!responseCreateAppt) {
          this.handleShowErrorTriggerExamination()
          this.isLoading = false
          return
        }

        const responseConfirmAppt = await this.handleConfirmAppointment(
          item,
          responseCreateAppt
        )
        if (!responseConfirmAppt) {
          this.handleShowErrorTriggerExamination()
          this.isLoading = false

          return
        }

        const responseCreateExamination = await this.handleCreateExamination(
          item,
          responseConfirmAppt
        )
        if (!responseCreateExamination) {
          this.handleShowErrorTriggerExamination()
          return
        }
        this.$router.replace({
          name: 'PatientVisitDetail',
          params: {
            id: responseCreateExamination?.id
          }
        })
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    async handleCreateAppointment (item) {
      const params = {
        WorkspaceId: this.$globalClinic?.id,
        CrId: this.consulting?.[0]?.ID,
        DoctorID: this.$user?.doctor?.id,
        StartTime: window.moment().format('YYYY-MM-DD HH:mm:ss'),
        EndTime: window
          .moment()
          .add(5, 'minutes')
          .format('YYYY-MM-DD HH:mm:ss'),
        SlotPrice: 0,
        SlotDuration: null,
        PersonId: item?.id,
        Method: 1,
        LineNumber: 0
      }
      return this.$rf
        .getRequest('DoctorRequest')
        .postAppts(params)
        .then((resp) => {
          return resp.data?.data
        })
        .catch((e) => {
          console.log(e)
        })
    },
    async handleConfirmAppointment (item, responseCreateAppt) {
      const params = {
        clinic_id: this.$globalClinic?.id,
        cr_id: this.consulting?.[0]?.ConsultingRoomID,
        doctor_id: this.$user?.doctor?.id,
        person_id: item?.id,
        start_time: window.moment().format('YYYY-MM-DD HH:mm:ss'),
        end_time: window
          .moment()
          .add(5, 'minutes')
          .format('YYYY-MM-DD HH:mm:ss'),
        appt_id: responseCreateAppt?.id,
        method: 1,
        checkin_time: window.moment(),
        visit_reason: ''
      }

      try {
        const response = await this.$rf
          .getRequest('DoctorRequest')
          .setPatientVisits(params)

        return response.data
      } catch (error) {
        console.log(error)
      }
    },
    async handleCreateExamination (item, responseConfirmAppt) {
      try {
        const params = {
          appt_id: responseConfirmAppt?.appt_id || null,
          clinic_id: responseConfirmAppt?.clinic_id || null,
          doctor_id: responseConfirmAppt?.doctor_id || null,
          cr_id: responseConfirmAppt?.cr_id || null,
          person_id: responseConfirmAppt?.person_id || null,
          start_time: responseConfirmAppt?.start_time
            ? window.moment(responseConfirmAppt.start_time).utc().format('YYYY-MM-DD HH:mm:ss')
            : null,
          end_time: responseConfirmAppt?.end_time
            ? window.moment(responseConfirmAppt.end_time).utc().format('YYYY-MM-DD HH:mm:ss')
            : null,
          checkin_time: responseConfirmAppt?.checkin_time
            ? window.moment(responseConfirmAppt.checkin_time).format('YYYY-MM-DD HH:mm:ss')
            : null,
          status: EXAMINATION_STATUS.CODE.BEING
        }

        const response = await this.$rf
          .getRequest('DoctorRequest')
          .updatePatientVisitsById(responseConfirmAppt?.id, params)

        return response.data
      } catch (error) {
        console.log(error)
      }
    },
    handleShowErrorTriggerExamination () {
      this.isLoading = false
      this.$message({
        type: 'error',
        message: this.$t('Có lỗi xảy ra khi tạo lượt khám')
      })
    },
    async getConsultingRooms () {
      const params = {
        limit: 10,
        page: this.page,
        Date: this.currentDate,
        CurrentTime: window.moment().format('YYYY-MM-DD HH:mm')
      }

      try {
        let resp = await this.$rf
          .getRequest('DoctorRequest')
          .getConsultingRoomWithDoctor(params, this.$globalClinic?.id)
        this.consulting = resp.data.data || []
      } catch (e) {
        // statements
        console.log(e)
      } finally {
      }
    }
  },
  destroyed () {
    this.cancelAutoUpdate()
  }
}
</script>
